export const medicalSurgicalAct = {
	pre_operative_diagnosis: "",
	post_operative_diagnosis: "",
	description: "",
	accident_during_surgery: "",
	blood_transfusion: "",
	histopathological_examination_material_sent: "",
	observations: "",
	fetal_situation: "",
	fetal_presentation: "",
	flexed_fetal_presentation: "",
	deflected_fetal_presentation_grade: "",
};
